module.exports = __webpack_public_path__ + "media/homepage/join-and-match-instantly_@2x-649da230.png";